
const MapSection = () => {
  return (
    <section className="py-20 bg-white px-6">
      <div className="max-w-[1400px] mx-auto">
        <div className="rounded-3xl overflow-hidden shadow-xl">
          <iframe
            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d26234.27771!2d133.9350!3d34.6617!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x0!2zMzTCsDM5JzQyLjEiTiAxMzPCsDU2JzA2LjAiRQ!5e0!3m2!1sja!2sjp!4v1234567890"
            width="100%"
            height="450"
            style={{ border: 0 }}
            allowFullScreen
            loading="lazy"
            referrerPolicy="no-referrer-when-downgrade"
            title="おかやま整形外科の地図"
          />
        </div>
      </div>
    </section>
  );
};

export default MapSection;
